module.exports = __webpack_public_path__ + "img/pr-6.2e6b03b2.png";